/**
 * 将起点时间显示为距离当前时间的相对时间格式
 * @param value 起点时间, 能转换成Date对象的数字, 字符串或者Date对象
 * @example $timeAgo('2019-05-19') => '29天后'
 * @example $timeAgo(1558051200000) => '29天后'
 * @example $timeAgo('2019-04-17 11:00:00') => '21分钟前'
 * @example $timeAgo('2019-04-17 11:00:00', '2019-04-17 11:01:00') => '1分钟前'
 */
export default function (value: any, date: any = null): string{
	function toDate (argument: any): Date{
		if (arguments.length < 1) {
			throw new Error('参数个数不正确, 请传递至少一个日期值!');
		}
		const argStr: string = Object.prototype.toString.call(argument);
		if (argument instanceof Date || (typeof argument === 'object' && argStr === '[object Date]')) {
			return new Date(argument.getTime());
		} else if (typeof argument === 'number' || argStr === '[object Number]') {
			return new Date(argument);
		} else if (typeof argument === 'string' || argStr === '[object String]') {
			try {
				return new Date(argument);
			} catch (e) {
				console.error('时间字符串类型转换失败, 使用当前时间初始化!');
			}
		}
		return new Date();
	}
	function isEarly (timeStamp: number, currentTime: number): boolean{
		return timeStamp <= currentTime;
	}
	function getHandledValue (num: Number): string{
		return num < 10 ? '0' + num : String(num);
	}
	function getDate (timeStamp: number, startType: string = ''): string{
		const d = new Date(timeStamp);
		const year = d.getFullYear();
		const month = getHandledValue(d.getMonth() + 1);
		const date = getHandledValue(d.getDate());
		const hours = getHandledValue(d.getHours());
		const minutes = getHandledValue(d.getMinutes());
		const second = getHandledValue(d.getSeconds());
		if (startType === 'year') {
			return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second;
		} else {
			return month + '-' + date + ' ' + hours + ':' + minutes;
		}
	}

	const timeStamp: number = toDate(value).getTime();
	const currentTime: number = toDate(date || new Date()).getTime();

	// 判断传入时间戳是否早于当前时间戳
	const IS_EARLY: boolean = isEarly(timeStamp, currentTime);
	// 获取两个时间戳差值
	let diff: number = currentTime - timeStamp;
	// 如果IS_EARLY为false则差值取反
	if (!IS_EARLY) diff = -diff;
	let resStr: string = '';
	let dirStr: string = IS_EARLY ? '前' : '后';

	const SECOND: number = 1000;
	const MINUTE: number = SECOND * 60;
	const HOUR: number = MINUTE * 60;
	const DAY: number = HOUR * 24;
	const MONTH: number = DAY * 30;
	const YEAR: number = DAY * 365;
	if (diff < SECOND) {
		//1秒内;
		return '刚刚';
	} else if (diff < MINUTE) {
		// 1分钟内
		return parseInt(String(diff / SECOND)) + '秒' + dirStr;
	} else if (diff >= MINUTE && diff < HOUR) {
		// 大于1分钟，小于1小时内
		return Math.floor(diff / MINUTE) + '分钟' + dirStr;
	} else if (diff >= HOUR && diff < DAY) {
		// 大于1小时，小于1天(24小时)内
		return Math.floor(diff / HOUR) + '小时' + dirStr;
	} else if (diff >= DAY && diff < MONTH) {
		//大于1天(24小时), 小于30天内
		return Math.floor(diff / DAY) + '天' + dirStr;
	} else if (diff >= MONTH && diff <= YEAR && IS_EARLY) {
		//大于30天, 小于365天并且入参早于当前时间;
		if (timeStamp > new Date(new Date().getFullYear(), 0, 1).getTime()) {
			//如果在当年内, 则显示月份与时间;
			return getDate(timeStamp);
		}
		return getDate(timeStamp, 'year');
	} else {
		return getDate(timeStamp, 'year');
	}
}
